import { FORM_ERROR } from "final-form";
import { get } from "lodash";
import React from "react";
import { Form as FinalForm } from "react-final-form";
import { connect } from "react-redux";
import { Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import { Col, Container, Row, Spinner } from "reactstrap";
import TextField from "../../components/Form/TextField/TextField";
import * as S from "../../constants/StringConstants";
import { IRootState } from "../../store/reducers";
import { validateEmail } from "../../store/reducers/authentication";
import FooterShort from "../Layout/FooterShort";
import HeaderHome from "../Layout/HeaderHome";
import "./Login.scss";

export interface ILoginProps extends StateProps, DispatchProps, RouteComponentProps {}

export class Login extends React.Component<ILoginProps> {
  onSubmit = async (values) => {
    const { email } = values;
    var authResult = await this.props.validateEmail(email);

    var failed = get(authResult, "failed");
    if (failed) {
      return {
        [FORM_ERROR]: get(authResult, "error"),
      };
    } else {
      var brokerId = get(authResult, "brokerId");
      const campaignId = get(this.props.match.params, "campaignId");

      let brokerUrl = "/broker/" + brokerId;
      if (campaignId) {
        brokerUrl += "/campaign/" + campaignId;
      }
      this.props.history.push(brokerUrl);
    }
  };

  render() {
    const { location, isAuthenticated } = this.props;
    const { from } = (location.state as any) || {
      from: { pathname: "/", search: location.search },
    };

    if (isAuthenticated) {
      return <Redirect to={from} />;
    }

    return (
      <div>
        <HeaderHome {...this.props} />

        <section className="login">
          <Container fluid>
            <Row>
              <Col>
                <div className="login__form-wrap">
                  <FinalForm
                    onSubmit={this.onSubmit}
                    render={({ handleSubmit, invalid, submitFailed, submitError, submitting }) => {
                      return (
                        <form noValidate className="login__form" onSubmit={handleSubmit}>
                          {submitFailed && <div className="not-valid">{submitError}</div>}

                          <h1 className="form-title">{S.QUOTE_ENGINE_LOGIN_LABEL}</h1>
                          <TextField
                            label={S.EMAIL_LABEL}
                            name="email"
                            type="email"
                            light={false}
                            validate={(value) => (value ? undefined : S.FORM_FIELD_REQUIRED)}
                          />

                          <button
                            className="button-v2 button-v2__primary"
                            type="submit"
                            disabled={submitting}>
                            {submitting ? <Spinner color="white" /> : S.LOGIN_SIGN_IN}
                          </button>
                        </form>
                      );
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <FooterShort />
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: IRootState) => ({
  isAuthenticated: auth.isAuthenticated,
});
const mapDispatchToProps = { validateEmail };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
